export function startswith(str, prefix) {
  return str && str.indexOf(prefix) === 0
}
export function endswith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1
}
